var _line, _line2, _path, _rect, _path2, _line3, _line4, _line5, _line6, _line7, _path3, _rect2, _path4, _line8, _line9, _line0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtJewishIcons = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 88,
    x2: 40,
    y2: 88,
    stroke: "#D28A60",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 88,
    x2: 30,
    y2: 76,
    stroke: "#D28A60",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 23,76 Q 23,72 30,72 Q 37,72 37,76 L 37,78 L 23,78 Z",
    stroke: "#D28A60",
    strokeWidth: 2,
    fill: "none",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 56,
    width: 7,
    height: 16,
    rx: 1,
    stroke: "#D28A60",
    strokeWidth: 2,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 30,56 Q 24,47 30,37 Q 36,47 30,56 Z",
    stroke: "#D28A60",
    strokeWidth: 2,
    fill: "none",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 33,
    x2: 30,
    y2: 28,
    stroke: "#D28A60",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 41,
    x2: 15,
    y2: 38,
    stroke: "#D28A60",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 41,
    x2: 45,
    y2: 38,
    stroke: "#D28A60",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 88,
    x2: 80,
    y2: 88,
    stroke: "#D28A60",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 88,
    x2: 70,
    y2: 76,
    stroke: "#D28A60",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 63,76 Q 63,72 70,72 Q 77,72 77,76 L 77,78 L 63,78 Z",
    stroke: "#D28A60",
    strokeWidth: 2,
    fill: "none",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 56,
    width: 7,
    height: 16,
    rx: 1,
    stroke: "#D28A60",
    strokeWidth: 2,
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 70,56 Q 64,47 70,37 Q 76,47 70,56 Z",
    stroke: "#D28A60",
    strokeWidth: 2,
    fill: "none",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 33,
    x2: 70,
    y2: 28,
    stroke: "#D28A60",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 41,
    x2: 55,
    y2: 38,
    stroke: "#D28A60",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 41,
    x2: 85,
    y2: 38,
    stroke: "#D28A60",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtJewishIcons);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-jewish-icons.8b0b817e8d78865a269351308373e38e.svg";